import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { connect } from "react-redux";
import * as actions from "../../../store/actions";
import { Pause, PlayArrow, Save } from "@mui/icons-material";
import { Box, FormControl, InputLabel, MenuItem, Select, Stack } from "@mui/material";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import Button from "../../../components/CustomButtons/Button";
import FiltersStyle from "./FiltersStyle";
import { withStyles } from "tss-react/mui";
import { convertObjectToSelectOptions } from "../../../templateHelpers";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import AsynchronousAutocomplete from "../../../components/Autocomplete/AsynchronousAutocomplete";
import { toast } from "react-toastify";
import CustomInput from "../../../components/CustomInput/CustomInput";
import { format, parse } from "date-fns";
import { DateTimePicker } from "@mui/x-date-pickers";
import JTooltip from "../../../../../Components/JTooltip";

class Filters extends React.PureComponent {
  state = {
    vestigingen: [],
    autoRenew: false,
    saveButtonDisabled: true,
    viewName: null,
    preOrderTimes: [],
    preOrderTimes_ids: ["all"],
    showAutoRenew: true,
    autoRenewTime: 30000,
    item_type_list: ["all"],
    item_source_type_list: ["all"],
    item_names_list: ["all"],
  };

  componentDidMount() {
    this.getPreOrderDates();
    const filterdata = this.getFilters();
    if (!this.props.showBiFilters) {
      this.props.onFilterChange(filterdata);
    }
  }

  componentWillUnmount() {
    /**
     * Current request annuleren bij snel klikken kan zijn dat die nog niet klaar is
     */
    if (this.currentVestigingReqeust !== undefined) {
      this.currentVestigingReqeust.cancel();
    }

    if (this.currentPreOrderReqeust !== undefined) {
      this.currentPreOrderReqeust.cancel();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const filterdata = this.getFilters();

    if (
      prevProps.startDate !== this.props.startDate ||
      prevProps.endDate !== this.props.endDate ||
      prevProps.vestigingIds !== this.props.vestigingIds
    ) {
      this.getPreOrderDates();
    }

    if (!this.props.showBiFilters) {
      this.props.onFilterChange(filterdata);
    }
  }

  getFilters = () => {
    return {
      vestiging_ids: this.props.vestigingIds,
      vestigingen: this.props.vestigingen,
      start_datum: this.props.startDate,
      eind_datum: this.props.endDate,
      preordertimes: this.props.preOrderTimesIds,
      item_source_type: this.props.item_source_type,
      item_source_type_list: this.props.item_source_type_list,
      item_type: this.props.item_type,
      item_type_list: this.props.item_type_list,
      item_names: this.props.item_names,
      item_names_list: this.props.item_names_list,
    };
  };

  loadFilterset = (filterId) => {
    axios
      .get("core/bi/get_filters?filter_id=" + filterId)
      .then((response) => {
        if (response.data.data.view_data !== undefined) {
          console.log(response.data);
          let viewFields = JSON.parse(response.data.data.view_data);
          console.log(viewFields);
          if (viewFields.view_name !== undefined) {
            this.setState({ viewName: viewFields.view_name, saveButtonDisabled: false });
          }
          if (viewFields.start_datum !== undefined) {
            console.log(viewFields.start_datum); // TODO CHECK
            this.props.handleDateChange("startDate", viewFields.start_datum);
          }
          if (viewFields.eind_datum !== undefined) {
            console.log(viewFields.eind_datum); // TODO CHECK
            this.props.handleDateChange("endDate", viewFields.eind_datum);
          }
          if (
            viewFields.item_source_type_list !== undefined &&
            viewFields.item_source_type !== undefined &&
            !viewFields.item_source_type_list.includes("all")
          ) {
            this.props.handleMultiSelectChange(
              "item_source_type",
              viewFields.item_source_type.map((option) => ({
                value: option.value,
                label: option.label,
              }))
            );
            this.props.handleMultiSelectChange("item_source_type_list", viewFields.item_source_type_list);
          }
          if (
            viewFields.item_type_list !== undefined &&
            viewFields.item_type !== undefined &&
            !viewFields.item_type_list.includes("all")
          ) {
            this.props.handleMultiSelectChange(
              "item_type",
              viewFields.item_type.map((option) => ({
                value: option.value,
                label: option.label,
              }))
            );
            this.props.handleMultiSelectChange("item_type_list", viewFields.item_type_list);
          }
          if (
            viewFields.item_names_list !== undefined &&
            viewFields.item_names !== undefined &&
            !viewFields.item_names_list.includes("all")
          ) {
            this.props.handleMultiSelectChange(
              "item_names",
              viewFields.item_names.map((option) => ({
                value: option.value,
                label: option.label,
              }))
            );
            this.props.handleMultiSelectChange("item_names_list", viewFields.item_names_list);
          }
          if (
            viewFields.vestiging_ids !== undefined &&
            viewFields.vestigingen !== undefined &&
            !viewFields.vestiging_ids.includes("all")
          ) {
            this.props.handleMultiSelectChange(
              "vestigingen",
              viewFields.vestigingen.map((option) => ({
                value: option.value,
                label: option.label,
              }))
            );
            this.props.handleMultiSelectChange("vestigingIds", viewFields.vestiging_ids);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        /**
         * Alleen niet CANCEL errors afvangen
         */
        if (!error.__CANCEL__) {
          toast.error("Oeps er is iets mis gegaan!");
        }
      });
    /*  return {
    "{"view_name": "test", "eind_datum": "2024-09-17T21:59:59.999Z", "start_datum": "2024-09-07T22:00:00.000Z", "preordertimes": ["all"], "vestiging_ids": [710, 711], "item_type_list": ["all"], "item_source_type_list": ["all"]}"
      vestiging_ids: this.props.vestigingIds,
      start_datum: this.props.startDate,
      eind_datum: this.props.endDate,
      preordertimes: this.props.preOrderTimesIds,
      item_source_type_list: this.props.item_source_type_list,
      item_type_list: this.props.item_type_list,
    };*/
  };

  saveFiltersToProfile = () => {
    axios
      .post("core/bi/save_view", { ...this.getFilters(), view_name: this.state.viewName })
      .then((response) => {
        console.log("ok");
      })
      .catch((error) => {
        console.log(error);
        /**
         * Alleen niet CANCEL errors afvangen
         */
        if (!error.__CANCEL__) {
          toast.error("Oeps er is iets mis gegaan!");
        }
      });
  };

  getPreOrderDates = () => {
    //Render pre order times
    if (this.props.showPreordertimes && this.props.vestigingen.length > 0) {
      const query = [];
      let vList = [];
      this.props.vestigingen.forEach((vid) => {
        vList.push(vid.value);
      });
      query.push({
        field: "vestiging_id",
        operator: "in",
        value: vList,
      });

      if (this.props.showStartDate) {
        query.push({
          field: "preordertime",
          operator: ">=",
          value: format(new Date(this.props.startDate), "yyyy-MM-dd 00:00:00"),
        });
      }

      if (this.props.showEndDate) {
        query.push({
          field: "preordertime",
          operator: "<=",
          value: format(this.props.endDate, "yyyy-MM-dd 23:59:59"),
        });
      }

      /**
       * CancelToken
       */
      const CancelToken = axios.CancelToken;
      this.currentPreOrderReqeust = CancelToken.source();
      let cancelToken = this.currentPreOrderReqeust.token;

      axios
        .post(
          "core/bestellingen/search?use_pagination=0&fields=vestiging_id,preordername, preordertime&group_by=preordertime, preordername&sort_field=preordertime",
          query,
          {
            cancelToken,
          }
        )
        .then((response) => {
          const preordertimes = response.data.data.data.map((prop, key) => {
            return {
              value: prop.preordertime,
              label:
                format(parse(prop.preordertime, "yyyy-MM-dd HH:mm:ss", new Date()), "d-M-yyyy H:mm") +
                " (" +
                prop.preordername +
                ")",
            };
          });

          this.setState({ preOrderTimes: preordertimes });
        })
        .catch((error) => {
          console.log(error);
          /**
           * Alleen niet CANCEL errors afvangen
           */
          if (!error.__CANCEL__) {
            toast.error("Oeps er is iets mis gegaan!");
          }
        });
    }
  };

  toggleAutoRenew = () => {
    if (!this.state.autoRenew) {
      this.intervalID = setInterval(() => {
        const filterdata = this.getFilters();
        this.props.onFilterChange(filterdata);
      }, this.state.autoRenewTime);
    } else {
      clearTimeout(this.intervalID);
    }

    this.setState({
      autoRenew: !this.state.autoRenew,
    });
  };

  render() {
    const { classes } = this.props;

    const preOrderTimesOpties = convertObjectToSelectOptions(this.state.preOrderTimes, classes);

    return (
      <div>
        {this.props.showSaveButton ? (
          <GridContainer>
            <GridItem md={4} xs={12}>
              <InputLabel className={classes.label}>
                <TranslationWrapper tDefault={"Load view"} tKey={"global.filtersettings_load"} />
              </InputLabel>

              <AsynchronousAutocomplete
                async={{
                  url: "core/bi/search_filters?view_type=BI_VIEW",
                  perPage: 150,
                }}
                onChange={(e, options) => {
                  this.loadFilterset(options.value);
                }}
                showTagsInInput={false}
              />
            </GridItem>
            <GridItem md={4} xs={12}>
              <InputLabel className={classes.label}>
                <TranslationWrapper tDefault={"Save view"} tKey={"global.filtersettings_save"} />
              </InputLabel>
              <CustomInput
                formControlProps={{
                  style: { paddingTop: "0" },
                  fullWidth: true,
                }}
                inputProps={{
                  type: "text",
                  name: "filter_name",
                  value: this.state.viewName,
                  onChange: (e) => {
                    if (e.target.value != "") {
                      this.setState({ saveButtonDisabled: false, viewName: e.target.value });
                    } else {
                      this.setState({ saveButtonDisabled: true, viewName: e.target.value });
                    }
                  },
                }}
              />
            </GridItem>
            <GridItem md={4} xs={12}>
              <Button
                className={classes.marginRight}
                color={"warning"}
                disabled={this.state.saveButtonDisabled}
                onClick={() => {
                  this.saveFiltersToProfile();
                }}
                size={"sm"}
                style={{ fontSize: "small", marginTop: "20px" }}
              >
                <Save className={classes.icons} /> {getTranslation("Save view", "Save view")}
              </Button>
            </GridItem>
          </GridContainer>
        ) : null}
        <Stack alignItems={"center"} direction={"row"} flexWrap={"wrap"} gap={3}>
          {/*Start date*/}

          {this.props.showStartDate ? (
            <DateTimePicker
              closeOnSelect
              defaultValue={new Date()}
              label={<TranslationWrapper tDefault={"Van"} tKey={"global.van"} />}
              maxDateTime={this.props.endDate}
              onChange={(date) => this.props.handleDateChange("startDate", date.getTime())}
              value={this.props.startDate}
            />
          ) : null}

          {this.props.showStartDateDate ? (
            <DateTimePicker
              closeOnSelect
              label={<TranslationWrapper tDefault={"Van"} tKey={"global.van"} />}
              maxDateTime={this.props.endDate}
              onChange={(date) => this.props.handleDateChange("startDate", date.getTime())}
              value={this.props.startDate}
            />
          ) : null}

          {/*End date*/}
          {this.props.showEndDate ? (
            <DateTimePicker
              closeOnSelect
              label={<TranslationWrapper tDefault={"Tot"} tKey={"global.tot"} />}
              minDateTime={this.props.startDate}
              onChange={(date) => this.props.handleDateChange("endDate", date.getTime())}
              value={this.props.endDate}
            />
          ) : null}

          {this.props.showEndDateDate ? (
            <DateTimePicker
              closeOnSelect
              label={<TranslationWrapper tDefault={"Tot"} tKey={"global.tot"} />}
              minDateTime={this.props.startDate}
              onChange={(date) => this.props.handleDateChange("endDate", date.getTime())}
              value={this.props.endDate}
            />
          ) : null}

          {/*Vestigingen*/}
          {this.props.showVestigingen ? (
            <Box sx={{ minWidth: 400 }}>
              {/*<InputLabel className={classes.label}>*/}
              {/*  {<TranslationWrapper tKey={"global.vestiging_multiselect"} tDefault={"Vestigingen (multiselect)"} />}*/}
              {/*</InputLabel>*/}

              <AsynchronousAutocomplete
                async={{
                  url: "core/vestigingen/search?fields=id as value, systeemNaam as label",
                  searchField: "systeemNaam",
                  perPage: 150,
                }}
                defaultValue={this.props.vestigingen}
                multiple
                onChange={(e, options) => {
                  this.props.handleMultiSelectChange(
                    "vestigingen",
                    options.map((option) => ({
                      value: option.value,
                      label: option.label,
                    }))
                  );
                  this.props.handleMultiSelectChange(
                    "vestigingIds",
                    options.map((option) => option.value)
                  );
                }}
                placeholder={getTranslation("global.vestiging_multiselect", "Vestigingen (multiselect)")}
                showTagsInInput={false}
              />

              {this.props.showBiFilters ? (
                <Button
                  className={classes.marginRight}
                  color={"success"}
                  onClick={() => {
                    this.props.onFilterChange(this.getFilters());
                  }}
                  size={"sm"}
                  style={{ fontSize: "small", marginTop: "20px" }}
                >
                  <Save className={classes.icons} /> {getTranslation("Load report data", "Load report data")}
                </Button>
              ) : null}
            </Box>
          ) : null}

          {/*Pre order times*/}
          {this.props.showPreordertimes ? (
            <GridItem md={4} xs={12}>
              <InputLabel className={classes.label}>
                <TranslationWrapper tDefault={"Pre order time"} tKey={"rapportages.filters.preOrderTime"} />
              </InputLabel>
              <FormControl className={classes.selectFormControl} fullWidth>
                <Select
                  MenuProps={{
                    className: classes.selectMenu,
                  }}
                  classes={{
                    select: classes.select,
                  }}
                  inputProps={{
                    name: "mainLanguage",
                    id: "mainLanguage",
                  }}
                  multiple
                  onChange={(event) => this.props.handleMultiSelectChange("preOrderTimesIds", event.target.value)}
                  value={this.props.preOrderTimesIds}
                >
                  <MenuItem
                    classes={{
                      root: classes.selectMenuItem,
                      selected: classes.selectMenuItemSelected,
                    }}
                    value={"all"}
                  >
                    {getTranslation("rapportages.filters.allePreOrderTimes", "Alle pre order times")}
                  </MenuItem>
                  {preOrderTimesOpties}
                </Select>
              </FormControl>
            </GridItem>
          ) : null}

          {/* auto refresh with filters */}
          {this.props.ShowReload && this.state.showAutoRenew ? (
            <JTooltip
              classes={{ tooltip: classes.tooltip }}
              placement={"bottom"}
              title={this.state.autoRenew ? "Pauze automatisch vernieuwen" : "Automatisch vernieuwen"}
            >
              <Button
                className={classes.renewButton}
                color={"primary"}
                justIcon
                onClick={this.toggleAutoRenew}
                size={"sm"}
                style={{ marginTop: "0px" }}
              >
                {this.state.autoRenew ? <Pause className={classes.icons} /> : <PlayArrow className={classes.icons} />}
              </Button>
            </JTooltip>
          ) : null}
        </Stack>
        {this.props.showBiFilters ? (
          <GridContainer>
            <GridItem md={4} xs={12}>
              <InputLabel className={classes.label}>
                <TranslationWrapper tDefault={"Item type"} tKey={"global.item_type_multiselect"} />
              </InputLabel>

              <AsynchronousAutocomplete
                async={{
                  url: "core/bi/item_type_list?fields=item_type as value, item_type as label",
                  searchField: "item_type",
                  perPage: 150,
                }}
                defaultValue={this.props.item_type}
                multiple
                onChange={(e, options) => {
                  this.props.handleMultiSelectChange(
                    "item_type",
                    options.map((option) => ({
                      value: option.value,
                      label: option.label,
                    }))
                  );
                  this.props.handleMultiSelectChange(
                    "item_type_list",
                    options.map((option) => option.value)
                  );
                }}
                showTagsInInput={false}
              />
            </GridItem>
            <GridItem md={4} xs={12}>
              <InputLabel className={classes.label}>
                <TranslationWrapper tDefault={"Item source type"} tKey={"global.item_source_multiselect"} />
              </InputLabel>

              <AsynchronousAutocomplete
                async={{
                  url: "core/bi/item_source_type_list?fields=item_type as value, item_type as label",
                  searchField: "item_source",
                  perPage: 150,
                }}
                defaultValue={this.props.item_source_type}
                multiple
                onChange={(e, options) => {
                  this.props.handleMultiSelectChange(
                    "item_source_type",
                    options.map((option) => ({
                      value: option.value,
                      label: option.label,
                    }))
                  );
                  this.props.handleMultiSelectChange(
                    "item_source_type_list",
                    options.map((option) => option.value)
                  );
                }}
                showTagsInInput={false}
              />
            </GridItem>
            {!this.props.vestigingIds.includes("all") ? (
              <GridItem key={this.props.vestigingIds.length + this.props.startDate + this.props.endDate} md={4} xs={12}>
                <InputLabel className={classes.label}>
                  <TranslationWrapper tDefault={"Items"} tKey={"global.items_multiselect"} />
                </InputLabel>

                <AsynchronousAutocomplete
                  async={{
                    url: "core/bi/item_names_list",
                    searchField: "item_name",
                    extraFilters: this.getFilters(),
                  }}
                  defaultValue={this.props.item_names}
                  multiple
                  onChange={(e, options) => {
                    this.props.handleMultiSelectChange(
                      "item_names",
                      options.map((option) => ({
                        value: option.value,
                        label: option.label,
                      }))
                    );
                    this.props.handleMultiSelectChange(
                      "item_names_list",
                      options.map((option) => option.value)
                    );
                  }}
                  showTagsInInput={false}
                />
              </GridItem>
            ) : null}
          </GridContainer>
        ) : null}
      </div>
    );
  }
}

Filters.propTypes = {
  showStartDate: PropTypes.bool,
  showStartDateDate: PropTypes.bool,
  showEndDate: PropTypes.bool,
  showEndDateDate: PropTypes.bool,
  showVestigingen: PropTypes.bool,
  showPreordertimes: PropTypes.bool,
  showBiFilters: PropTypes.bool,
  showSaveButton: PropTypes.bool,
  showReload: PropTypes.bool,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
};

//REDUX
const mapStateToProps = (state) => {
  return {
    startDate: state.rapportage.startDate,
    endDate: state.rapportage.endDate,
    vestigingIds: state.rapportage.vestigingIds,
    vestigingen: state.rapportage.vestigingen,
    preOrderTimesIds: state.rapportage.preOrderTimesIds,
    userLocale: state.user.lang,
    item_type: state.rapportage.item_type,
    item_type_list: state.rapportage.item_type_list,
    item_source_type: state.rapportage.item_source_type,
    item_source_type_list: state.rapportage.item_source_type_list,
    item_names: state.rapportage.item_names,
    item_names_list: state.rapportage.item_names_list,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
    handleDateChange: (item, date) => dispatch({ type: actions.HANDLE_DATE_CHANGE, item: item, date: date }),
    handleMultiSelectChange: (item, value) =>
      dispatch({
        type: actions.HANDLE_MULTISELECT,
        item: item,
        selected: value,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(Filters, FiltersStyle));
